
const KEY_MAPPING = {
    'a': 0,
    'w': 1,
    's': 2,
    'e': 3,
    'd': 4,
    'f': 5,
    't': 6,
    'g': 7,
    'y': 8,
    'h': 9,
    'u': 10,
    'j': 11,
    'k': 12,
    'o': 13,
    'l': 14
};

class ComputerKeyboard {
    constructor() {
        this.octave = 0;
    }

    getTransposeForKey(key) {
        let offset = this.octave * 12;
        key = key.toLowerCase();

        if (key in KEY_MAPPING) {
            return offset + KEY_MAPPING[key];
        } else {
            return undefined;
        }
    }

    upOctave() {
        if (this.octave < 3) {
            this.octave++;
        }
    }

    downOctave() {
        if (this.octave > -2) {
            this.octave--;
        }
    }
}

export default ComputerKeyboard;
